module.exports = __webpack_public_path__ + "img/platform-oculus-quest.f0504250.png";